import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCryptoOther = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_383_296)",
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#EEEEEE"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M19.5 10.0508C19.8328 10.0173 20.1665 10.001 20.5 10.001V7H24.5V10.8359C26.4568 11.69 28.0909 13.1481 29.1602 15L25.6963 17C25.0359 15.8561 24.0162 14.9625 22.7959 14.457C21.5757 13.9516 20.223 13.8623 18.9473 14.2041C17.6715 14.5459 16.5443 15.2998 15.7402 16.3477C14.9362 17.3955 14.5 18.6792 14.5 20C14.5 21.3208 14.9362 22.6045 15.7402 23.6523C16.5443 24.7002 17.6715 25.4541 18.9473 25.7959C20.223 26.1377 21.5757 26.0484 22.7959 25.543C24.0162 25.0375 25.0359 24.1439 25.6963 23L29.1602 25C28.091 26.8518 26.4567 28.309 24.5 29.1631V33H20.5V29.998C20.1665 29.9981 19.8328 29.9817 19.5 29.9482V33H15.5V28.6572C14.3705 28.0049 13.3707 27.136 12.5664 26.0879C11.2263 24.3414 10.5 22.2013 10.5 20C10.5 17.7987 11.2263 15.6586 12.5664 13.9121C13.3708 12.8638 14.3704 11.9942 15.5 11.3418V7H19.5V10.0508Z",
			fill: "#515452"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_383_296",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgCryptoOther;
